import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AppearanceShow14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.00005 4.25C5.48127 4.25 4.25005 5.48122 4.25005 7C4.25005 8.51878 5.48127 9.75 7.00005 9.75C8.51883 9.75 9.75005 8.51878 9.75005 7C9.75005 5.48122 8.51883 4.25 7.00005 4.25ZM5.75005 7C5.75005 6.30964 6.30969 5.75 7.00005 5.75C7.69041 5.75 8.25005 6.30964 8.25005 7C8.25005 7.69036 7.69041 8.25 7.00005 8.25C6.30969 8.25 5.75005 7.69036 5.75005 7Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.400087 6.54967C0.200087 6.81634 0.200402 7.18408 0.400401 7.45075C1.94099 9.49931 4.28635 11.75 6.99984 11.75C9.71322 11.75 12.0598 9.49907 13.5998 7.45C13.7998 7.18333 13.7993 6.81592 13.5993 6.54925C12.0587 4.50069 9.71334 2.25 6.99984 2.25C4.28651 2.25 1.94026 4.50078 0.400087 6.54967ZM12.0332 7C10.8062 5.56414 9.00944 3.75 6.99984 3.75C4.99024 3.75 3.19347 5.56414 1.96651 7C3.19347 8.43586 4.99024 10.25 6.99984 10.25C9.00945 10.25 10.8062 8.43585 12.0332 7Z'
      fill='currentColor'
    />
  </Svg>
);

AppearanceShow14.displayName = 'AppearanceShow14';
export default AppearanceShow14;
